import axios, { AxiosResponse } from 'axios';
import { getMolecularUrl, getOneformBFFApiKey, getOneformBFFUrl, reportErrorSentry } from 'src/bff';
import { formDataBuilder } from 'src/forms';
import { MolecularResponse, OneformBFFResponse } from 'src/types';

export const oneformBFFFilesEmailSend = async (formData: FormData, files?: File[]): Promise<AxiosResponse<OneformBFFResponse>> => {
	try {
		if (files) {
			files.forEach((file, index) => {
				formData.append(`file_${index}`, file);
			});
		}

		const oneformBFFUrl = getOneformBFFUrl();
		const oneformBFFApiKey = getOneformBFFApiKey();
		const response = await axios.post(`${oneformBFFUrl}/files/email`, formData, {
			headers: {
				'X-Api-Key': oneformBFFApiKey,
				'Content-Type': 'multipart/form-data',
			},
		});

		return response;
	} catch (error) {
		reportErrorSentry(error);
		return null;
	}
};

export const oneformBFFNdpsSend = async (formData: FormData): Promise<AxiosResponse<OneformBFFResponse>> => {
	try {
		const oneformBFFUrl = getOneformBFFUrl();
		const oneformBFFApiKey = getOneformBFFApiKey();
		const response = await axios.post(`${oneformBFFUrl}/ndps/responses`, formData, {
			headers: {
				'X-Api-Key': oneformBFFApiKey,
			},
		});

		return response;
	} catch (error) {
		reportErrorSentry(error);
		return null;
	}
};

export const bffNdpsSend = async (data: any): Promise<{ success: boolean; response: AxiosResponse<OneformBFFResponse> | null }> => {
	try {
		const dataStringified = JSON.stringify(data);
		const dataParsed = JSON.parse(dataStringified);
		const formData = formDataBuilder(dataParsed);

		const oneformBFFUrl = getOneformBFFUrl();
		const oneformBFFApiKey = getOneformBFFApiKey();
		const response = await axios.post(`${oneformBFFUrl}/ndps/responses`, formData, {
			headers: {
				'X-Api-Key': oneformBFFApiKey,
			},
		});

		return { success: response?.data?.status?.code == 200, response };
	} catch (error) {
		reportErrorSentry(error);
		return { success: false, response: null };
	}
};

export const bffCallmeSend = async (data: any): Promise<{ success: boolean; response: AxiosResponse<OneformBFFResponse> | null }> => {
	try {
		const dataStringified = JSON.stringify(data);
		const dataParsed = JSON.parse(dataStringified);
		const formData = formDataBuilder(dataParsed);

		const oneformBFFUrl = getOneformBFFUrl();
		const oneformBFFApiKey = getOneformBFFApiKey();
		const response = await axios.post(`${oneformBFFUrl}/callme/email`, formData, {
			headers: {
				'X-Api-Key': oneformBFFApiKey,
			},
		});

		return { success: response?.data?.status?.code == 200, response };
	} catch (error) {
		reportErrorSentry(error);
		return { success: false, response: null };
	}
};

export const oneformBFFNdpsYumiwiSend = async (formData: FormData): Promise<AxiosResponse<OneformBFFResponse>> => {
	try {
		const oneformBFFUrl = getOneformBFFUrl();
		const oneformBFFApiKey = getOneformBFFApiKey();
		const response = await axios.post(`${oneformBFFUrl}/ndps/responses/yumiwi`, formData, {
			headers: {
				'X-Api-Key': oneformBFFApiKey,
			},
		});

		return response;
	} catch (error) {
		reportErrorSentry(error);
		return null;
	}
};

export const oneformBFFYumiwiSend = async (formData: FormData, authToken: string): Promise<AxiosResponse<OneformBFFResponse>> => {
	try {
		const oneformBFFUrl = getOneformBFFUrl();
		const oneformBFFApiKey = getOneformBFFApiKey();
		const response = await axios.post(`${oneformBFFUrl}/yumiwi/attendees`, formData, {
			headers: {
				'X-Api-Key': oneformBFFApiKey,
				'X-Auth-Token': authToken,
			},
		});

		return response;
	} catch (error) {
		reportErrorSentry(error);
		return null;
	}
};

export const dpsSend = async (formData: FormData): Promise<AxiosResponse<MolecularResponse>> => {
	try {
		const MOLECULAR_URL = getMolecularUrl(); // Legacy
		const response = await axios.post(`${MOLECULAR_URL}/request-dps-send.php`, formData);
		return response;
	} catch (error) {
		reportErrorSentry(error);
		return null;
	}
};

export const yumiwiSend = async (formData: FormData): Promise<AxiosResponse<MolecularResponse>> => {
	try {
		const MOLECULAR_URL = getMolecularUrl(); // Legacy
		const response = await axios.post(`${MOLECULAR_URL}/request-dps-send-yumiwi.php`, formData);
		return response;
	} catch (error) {
		reportErrorSentry(error);
		return null;
	}
};

export const raceSend = async (formData: FormData): Promise<AxiosResponse<MolecularResponse>> => {
	try {
		const MOLECULAR_URL = getMolecularUrl(); // Legacy
		const response = await axios.post(`${MOLECULAR_URL}/request-race-callme.php`, formData);
		return response;
	} catch (error) {
		reportErrorSentry(error);
		return null;
	}
};

export const motorflashSend = (formData: FormData): Promise<MolecularResponse> => {
	const MOLECULAR_URL = getMolecularUrl(); // Legacy

	return axios
		.post(`${MOLECULAR_URL}/request-motorflash-send.php`, formData)
		.then((response: AxiosResponse<MolecularResponse>) => response.data)
		.catch((error) => error);
};
